import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { useContactModal } from './ContactModalContext';
export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const {
    openModal
  } = useContactModal();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollTo = (id: string) => {
    setMobileMenuOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const handleCTA = () => {
    setMobileMenuOpen(false);
    openModal('expert');
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-offwhite/90 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-143">
      <div className="max-w-6xl mx-auto px-6 flex items-center justify-between" data-id="element-144">
        <div className="flex items-center gap-2 cursor-pointer" onClick={() => window.scrollTo(0, 0)} data-id="element-145">
          <div className="w-8 h-8 rounded-full bg-sage flex items-center justify-center" data-id="element-146">
            <div className="w-3 h-3 rounded-full bg-offwhite" data-id="element-147" />
          </div>
          <span className="font-serif font-medium text-xl tracking-tight text-navy" data-id="element-148">
            Консилиум
          </span>
        </div>

        <nav className="hidden md:flex items-center gap-8" data-id="element-149">
          <button onClick={() => scrollTo('how-it-works')} className="text-sm font-medium text-navyLight hover:text-sage transition-colors" data-id="element-150">
            Как это работает
          </button>
          <button onClick={() => scrollTo('pricing')} className="text-sm font-medium text-navyLight hover:text-sage transition-colors" data-id="element-151">
            Цена
          </button>
          <button onClick={() => scrollTo('faq')} className="text-sm font-medium text-navyLight hover:text-sage transition-colors" data-id="element-152">
            Вопросы
          </button>
          <button onClick={handleCTA} className="bg-sage hover:bg-sageDark text-white px-5 py-2.5 rounded-full text-sm font-medium transition-all duration-300 shadow-sm hover:shadow-md" data-id="element-153">
            Заказать экспертную оценку
          </button>
        </nav>

        <button className="md:hidden text-navy" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-154">
          {mobileMenuOpen ? <X size={24} data-id="element-155" /> : <Menu size={24} data-id="element-156" />}
        </button>
      </div>

      {mobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-offwhite border-t border-beige shadow-lg p-6 flex flex-col gap-4 md:hidden" data-id="element-157">
          <button onClick={() => scrollTo('how-it-works')} className="text-left text-lg font-medium text-navy py-2" data-id="element-158">
            Как это работает
          </button>
          <button onClick={() => scrollTo('pricing')} className="text-left text-lg font-medium text-navy py-2" data-id="element-159">
            Цена
          </button>
          <button onClick={() => scrollTo('faq')} className="text-left text-lg font-medium text-navy py-2" data-id="element-160">
            Вопросы
          </button>
          <button onClick={handleCTA} className="bg-sage text-white px-6 py-3 rounded-full text-center font-medium mt-4" data-id="element-161">
            Заказать экспертную оценку
          </button>
        </div>}
    </header>;
};